<app-tab>
  <app-interventions-toolbar (generate)="load($event)" [grid]="grid"></app-interventions-toolbar>
  <dx-data-grid
    #grid
    id="trailerInterventionsGridContainer"
    [ngStyle]="gridCss"
    [dataSource]="ds"
    [showRowLines]="true"
    [remoteOperations]="{ paging: true, sorting: true, filtering: true}"
    [allowColumnReordering]="true"
    [allowColumnResizing]="true"
    [rowAlternationEnabled]="true"
    [columnHidingEnabled]="false"
    [columnAutoWidth]="true"
    [errorRowEnabled]="false"
    [libGridTitle]="{text: 'Interventions'}"
    (onRowDblClick)="showInterventionDetails($event)"
    (onRowExpanding)="onRowExpanding($event)"
    (onRowUpdating)="onRatingUpdate($event)"
    [showBorders]="false">

    <dxi-column
      caption="ID"
      dataField="id"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column caption="Date et Heures">
      <dxi-column
        caption="Date"
        dataField="start_time"
        sortOrder="desc"
        format="shortDate"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Début"
        dataField="start_time"
        format="shortTime"
        dataType="date">
      </dxi-column>

      <dxi-column
        caption="Fin"
        dataField="stop_time"
        format="shortTime"
        dataType="date">
      </dxi-column>
    </dxi-column>

    <dxi-column
      caption="Opération"
      [width]="100"
      dataField="trailer_operation_type">
    </dxi-column>

    <dxi-column caption="Domaine">
      <dxi-column caption="Nom" dataField="domain_name"></dxi-column>
      <dxi-column caption="BU" dataField="business_unit_name"></dxi-column>
    </dxi-column>

    <dxi-column caption="Parcelle">
      <dxi-column
        caption="Nom"
        dataField="field.name">
      </dxi-column>
      <dxi-column
        caption="Superficie"
        [width]="100"
        [customizeText]="hectareUnit"
        dataField="field.polygon_area">
      </dxi-column>
      <dxi-column
        caption="Superficie Travaillée"
        dataType="number"
        format="#0.## Ha"
        dataField="working_area_ha">
      </dxi-column>
      <dxi-column
        caption="Percentage"
        dataType="number"
        format="percent"
        [width]="100"
        dataField="working_area_percent">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Tracteur">
      <dxi-column
        caption="Nom"
        dataField="tractor_name">
      </dxi-column>
      <dxi-column
        caption="Puissance"
        [width]="80"
        dataField="tractor_engine_power">
      </dxi-column>
      <dxi-column
        caption="Outil"
        dataField="trailer_name">
      </dxi-column>
      <dxi-column
        caption="Largeur"
        [width]="80"
        [customizeText]="widthUnit"
        dataField="trailer_width">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Durée (H:m)">
      <dxi-column caption="Totale" dataField="total_duration" cellTemplate="tmp"
                  [width]="80">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Totale Travail" dataField="total_working_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Arrêt Travail" dataField="stop_working_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
      <dxi-column caption="Totale Trajet" dataField="total_road_duration" cellTemplate="tmp"
                  [width]="120">
        <span *dxTemplate="let d of 'tmp'"
              style="border-bottom: 1px dotted;" [title]="durationToHoursStr(d)">{{durationToStr(d)}}</span>
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Vitesse">
      <dxi-column
        caption="Moyenne (km/h)"
        dataType="number"
        format="#0.##"
        dataField="working_in_field_speed_avg">
      </dxi-column>

      <dxi-column
        caption="Maximale (km/h)"
        dataType="number"
        format="#0.##"
        dataField="working_in_field_speed_max">
      </dxi-column>

      <dxi-column
        caption="Débit (Ha/h)"
        dataType="number"
        format="#0.##"
        dataField="working_hectare_per_hour">
      </dxi-column>
    </dxi-column>

    <dxi-column caption="Carburant">
      <dxi-column
        caption="Totale (L)"
        dataType="number"
        format="#0.##"
        dataField="total_fuel_consumption">
      </dxi-column>

      <dxi-column
        caption="Par Hectare (L/Ha)"
        dataType="number"
        format="#0.##"
        dataField="fuel_consumption_per_hectare">
      </dxi-column>
    </dxi-column>

    <dxi-column
      caption="Précision des Données"
      [width]="220"
      dataField="data_accuracy_rating"
      cellTemplate="accuracyRatingTemplate"
      editCellTemplate="accuracyRatingEditor"
      [setCellValue]="setRatingValue"
      [allowEditing]="canEdit">
      <div *dxTemplate="let cellInfo of 'accuracyRatingTemplate'">
        <lib-badge *ngIf="cellInfo.value" [color]="getAccuracyRatingColor(cellInfo.value)">
          {{getAccuracyRatingLabel(cellInfo.value)}}
        </lib-badge>
        <span *ngIf="!cellInfo.value" class="text-gray-400 text-sm">Non évalué</span>
      </div>
      <div *dxTemplate="let cellInfo of 'accuracyRatingEditor'">
        <dx-select-box
          [dataSource]="accuracyRatingOptions"
          displayExpr="label"
          valueExpr="value"
          [value]="cellInfo.value"
          (onValueChanged)="cellInfo.setValue($event.value)"
          [searchEnabled]="false"
          placeholder="Sélectionner une option">
        </dx-select-box>
      </div>
    </dxi-column>

    <dxi-column type="buttons">
      <dxi-button
        hint="Alerts"
        [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + alertsIcon.body + '</svg>'"
        [onClick]="expandAlerts"></dxi-button>
      <dxi-button
        hint="Détails"
        [icon]="'<svg width=\'18px\' height=\'18px\' viewBox=\'0 0 24 24\'>' + reportIcon.body + '</svg>'"
        [onClick]="showInterventionDetails"></dxi-button>
    </dxi-column>

    <dxo-summary>
      <dxi-total-item
        column="working_area_ha"
        valueFormat="#0.##"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="working_area_percent"
        valueFormat="percent"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_working_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="stop_working_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="total_road_duration"
        [customizeText]="durationToStr"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="working_in_field_speed_max"
        valueFormat="#0.##"
        summaryType="max">
      </dxi-total-item>
      <dxi-total-item
        column="working_in_field_speed_avg"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="working_hectare_per_hour"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
      <dxi-total-item
        column="total_fuel_consumption"
        valueFormat="#0.##"
        summaryType="sum">
      </dxi-total-item>
      <dxi-total-item
        column="fuel_consumption_per_hectare"
        valueFormat="#0.##"
        summaryType="avg">
      </dxi-total-item>
    </dxo-summary>

    <dxo-selection
      selectAllMode="page"
      mode="multiple"
    ></dxo-selection>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-interventions"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-paging [pageSize]="25"></dxo-paging>

    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>

    <dxo-filter-row [visible]="true"></dxo-filter-row>

    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>

    <dxo-header-filter [visible]="true"></dxo-header-filter>

    <dxo-editing
      mode="batch"
      [allowUpdating]="canEdit"
      [allowAdding]="false"
      [allowDeleting]="false">
    </dxo-editing>

    <dxo-master-detail [enabled]="false" template="masterDetail"></dxo-master-detail>

    <div *dxTemplate="let masterDetailItem of 'masterDetail'">
      <dx-data-grid
        [dataSource]="alerts"
        [showBorders]="true">
        <dxo-paging [pageSize]="5"></dxo-paging>
        <dxi-column caption="Alerts" dataField="message"></dxi-column>
      </dx-data-grid>
    </div>
  </dx-data-grid>
</app-tab>

<app-intervention-report
  [(visible)]="reportVisible"
  [intervention]="selectedIntervention"
  [request]="request">
</app-intervention-report>
